import { SimpleGrid, Stack } from "@mantine/core";
import { SimpleBreadcrumbs } from "../../../components/SimpleBreadcrumbs";
import { FormattedMessage, useIntl } from "react-intl";
import { useTRPC } from "../../../trpc";
import { useMemo } from "react";
import { SourceList } from "./components/SourceList";
import { LayerList } from "./components/LayerList";
import { useQuery } from "@tanstack/react-query";
import { tilesetDashboardLayoutRoute } from "./routes";
import { usePathAccountName } from "../../../hooks/router";

export function TilesetConfig() {
  const intl = useIntl();
  const trpc = useTRPC();
  const account = usePathAccountName();
  const { tileset } = tilesetDashboardLayoutRoute.useParams();
  const { dataset } = tilesetDashboardLayoutRoute.useSearch();

  const { data: current } = useQuery(trpc.getTilesetAndVersion.queryOptions({
    tileset,
    dataset,
    account,
  }, {
    refetchInterval: 1000 * 60 * 5,
    refetchOnMount: false,
  }));

  const { data: sources } = useQuery(trpc.getTilesetSources.queryOptions({
    tileset,
  }, {
    refetchInterval: 1000 * 60 * 5,
    refetchOnMount: false,
  }));

  const config = useMemo(() => {
    return current?.version?.config;
  }, [current]);

  return (
    <Stack gap={16} px="md" my="md">
      <SimpleBreadcrumbs
        parent={intl.formatMessage({ defaultMessage: "Config", id: "navigation.config" })}
        current={dataset ? `${dataset} - ${tileset}` : tileset}
        description={
          <FormattedMessage id="text.tilesetConfigDescription" defaultMessage="View your tileset config" />
        }
      />
      <Stack>
        {config && sources && (
          <SimpleGrid cols={{ base: 1, lg: 2 }} spacing="xs">
            <SourceList config={config} sources={sources} />
            <LayerList config={config} sources={sources} />
          </SimpleGrid>
        )}
      </Stack>
    </Stack>
  );
}
